import { useState, useEffect } from "react";

// Importing bootstrap components
import { Card } from "react-bootstrap";

// Importing payroll note mutations
import { useGetPayrollNoteByIdQuery } from "state/slices/analytics/analyticsApiSlice";

const NO_UPDATES_MESSAGE = "No updates available.";

const PayrollNote = ({ year, month, employeeId }) => {
  const [payrollNote, setPayrollNote] = useState(NO_UPDATES_MESSAGE);

  // Fetch payroll note
  const {
    data: payrollNoteData,
    isLoading,
    isError,
    isSuccess,
  } = useGetPayrollNoteByIdQuery({
    year,
    month,
    id: employeeId,
  });

  useEffect(() => {
    if (isError) {
      // On API error (including 404), reset to fallback message
      setPayrollNote(NO_UPDATES_MESSAGE);
    } else if (isSuccess && payrollNoteData) {
      setPayrollNote(payrollNoteData.note);
    }
  }, [payrollNoteData, isError]);

  return (
    <Card>
      <Card.Body>
        <h5 className="card-title">
          <i className="bi bi-info-circle-fill text-primary me-2"></i> Payroll
          Note
        </h5>
        <div className="mt-3">
          <h6 className="fs-6 fw-medium">{isLoading ? "Loading..." : payrollNote}</h6>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PayrollNote;
